import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getLoanApplicationTagAssignmentsHistoryAction } from 'store/loanApplications/actions';

import { HistoryTable } from '../../sharedComponents';

import { loanTagsHistoryConfig } from './LoanTagsHistory.config';

const LoanTagsHistory = ({ isLoading, setIsLoading }) => {
  const dispatch = useDispatch();

  const { applicationId } = useParams();

  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);

  const fetchData = useCallback(() => {
    setIsLoading(true);
    setIsError(false);

    dispatch(getLoanApplicationTagAssignmentsHistoryAction({ applicationId }))
      .then(data => setData(data))
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false));
  }, [dispatch, applicationId, setIsLoading]);

  useEffectSafeStrictMode(() => {
    fetchData();
  }, [fetchData]);

  return (
    <HistoryTable
      config={loanTagsHistoryConfig}
      data={data}
      fetchData={fetchData}
      isError={isError}
      isLoading={isLoading}
    />
  );
};

LoanTagsHistory.propTypes = {
  ...WithLoadingPropTypes,
};

export default withLoading(LoanTagsHistory);
